import React, { memo, useCallback } from 'react';

import type { Tab, VITRINS_OFFERS_TYPE } from '@sravni/ugc/lib/specialOffers/types';

import type { EventPayload, MessageParams } from '../../helpers/sendMessageToParentWindow';

import type { IActionBlockList, IOffersBlockList } from './components/HorizontalBlockList';
import { HorizontalBlockList } from './components/HorizontalBlockList';

interface BlockListProps {
  sendMessageToParentWindow: (params: MessageParams) => void;
  isMobile: boolean;
  maxDesktopVisibleItems: number;
  items: any[];
  activeTabType: Tab<VITRINS_OFFERS_TYPE>;
  contentRef: React.RefObject<HTMLDivElement>;
}

export const BlockList = memo(
  ({ sendMessageToParentWindow, isMobile, maxDesktopVisibleItems, items, contentRef }: BlockListProps) => {
    const handleEvent = useCallback(
      (event: EventPayload) =>
        sendMessageToParentWindow({
          type: 'pushEvent',
          event,
        }),
      [sendMessageToParentWindow],
    );

    const blocksInTwoRows = !isMobile || (!isMobile && maxDesktopVisibleItems > 4);

    const propsForBlockList: IOffersBlockList | IActionBlockList = {
      items,
      handleEvent,
      isMobile,
      maxDesktopVisibleItems,
      contentRef,
      blocksInTwoRows,
    };

    // if (activeTabType === COMMON_OFFERS.mortgage) {
    //   return <VerticalBlockList {...propsForBlockList} />;
    // }

    return <HorizontalBlockList {...propsForBlockList} />;
  },
);
